import { useController, useFormContext } from 'react-hook-form';
// eslint-disable-next-line import/no-named-as-default-member
import TextAreaComponent from './component';

const TextArea = ({
  name,
  required = false,
  isClearable = false,
  defaultValue = '',
  ...restProps
}) => {
  const { control, setValue } = useFormContext() || {};

  const {
    field: { ref, ...inputProps },
    fieldState: { error, isDirty },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue,
    shouldUnregister: false,
  });

  return (
    <TextAreaComponent
      {...inputProps}
      {...restProps}
      error={error}
      required={required}
      name={name}
      isDirty={isDirty}
      inputRef={ref}
      onClear={isClearable && inputProps.value ? () => {
        setValue(name, defaultValue, {
          shouldDirty: true,
        });
      } : undefined}
    />
  );
};

export default TextArea;
